import Login from '../views/Login.vue';

export default [
  {
    path: '/',
    name: 'Dashboard',
    component: () =>
      import(/* webpackChunkName: "Dashboard" */ '../views/Dashboard'),
    meta: {
      requiresAuth: true,
      title: 'Wenn - Dashboard'
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/users',
    name: 'Users',
    component: () =>
      import(/* webpackChunkName: "Members" */ '../views/Members'),
    meta: {
      requiresAuth: true,
      title: 'Wenn - Users'
    },
    props: {
      type: 'users'
    }
  },
  {
    path: '/partners',
    name: 'Partners',
    component: () =>
      import(/* webpackChunkName: "Members" */ '../views/Members'),
    meta: {
      requiresAuth: true,
      title: 'Wenn - Partners'
    },
    props: {
      type: 'partners'
    }
  },
  {
    path: '/photos',
    name: 'Photos',
    component: () => import(/* webpackChunkName: "Photos" */ '../views/Photos'),
    meta: {
      requiresAuth: true,
      title: 'Wenn - Photos'
    }
  },
  {
    path: '/404',
    alias: '*',
    name: 'notFound',
    component: () =>
      import(/* webpackChunkName: "notFound" */ '../views/notFound'),
    meta: {
      requiresAuth: true,
      title: 'Wenn - 404'
    }
  }
];
